import React from 'react';
import { HashRouter as Router, Switch } from 'react-router-dom';
import { GameLoader } from './GameLoader';

import { Route } from './Route';
import { Login } from './Login';
import { Join } from './Join';
import { Lobby } from './Lobby';
import { Game } from './Game';
import { Review } from './Review';
import { AppContainer } from './AppContainer';

export const Routes = () => {
    return (
        <Router>
            <Route path="/">
                <AppContainer>
                    <Switch>
                        <Route path="/lobby/:id">
                            <Lobby />
                        </Route>
                        <Route path="/game/:id">
                            <Switch>
                                <Route path="/game/:id/review/:userId">
                                    <Review />
                                </Route>
                                <Route path="/game/:id">
                                    <GameLoader children={({ users }) => <Game users={users} />} />
                                </Route>
                            </Switch>
                        </Route>
                        <Route path="/login">
                            <Login />
                        </Route>
                        <Route path="/">
                            <Join />
                        </Route>
                    </Switch>
                </AppContainer>
            </Route>
        </Router>
    );
};

